<template>
  <div class="layout">
    <div v-for="(meal, idx) in meals" :key="idx" class="item">
      <div class="columns is-marginless is-flex is-mobile">
        <div class="column is-paddingless is-flex is-four-fifth">
          <span class="meal-name">{{ meal.name }}</span>
          <div class="allergens">{{ allergens(meal.allergens) }}</div>
          <div class="badges">
            <div
              class="icon badge"
              v-for="badge in badges(meal.badges)"
              :key="badge.name"
            >
              <img :src="badge.icon" />
            </div>
          </div>
        </div>
        <div class="column is-2 is-paddingless has-text-right">
          {{ meal.price | money }} {{ currency }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { state } from "@/store"
import { allergenCodes, badgeCodes } from "@/service/meal-constants"
import { slicer } from "@/utils"

export default {
  maxMeals: 13,
  slicer: slicer.fillMaximumMealsPerScreen,
  name: "layout-list-default",
  props: ["meals"],
  computed: {
    currency() {
      return state.project.data.currency
    }
  },
  methods: {
    allergens(allergens) {
      return allergenCodes(allergens, "(", ")")
    },
    badges(badges) {
      return badgeCodes(badges)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.layout {
  background-color: black;
  padding: 0.5em;
  .item {
    color: #ff6600;
    font-size: 3.4em;
    .meal-name {
      white-space: pre-wrap;
    }
    .allergens {
      padding-left: 0.7em;
      padding-right: 0.7em;
      font-size: 0.65em;
      color: lightgray;
    }
    .badges {
      width: 5em;
      .badge {
        padding-right: 0.25em;
        padding-bottom: 0.25em;
        height: 1em;
        width: 1em;
        filter: drop-shadow(0.1em 0.1em 0.1em $screen-border-color);
        img {
          width: 100%;
          filter: grayscale(49%) contrast(100);
        }
      }
    }
  }
}
</style>
